module.exports = __webpack_public_path__ + "static/media/fifth_home.e3f3f1ca.png";